import React, { Component } from 'react';

import { SlButton } from '../editors';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { connect } from "react-redux";
import { history } from "../../_helpers";
import { registrationActions, userActions } from "../../_actions";
import { metadataService, userService, workflowService, ServiceUtil } from "../../_services";
import { newLoanStepperService } from "../../_services";
import { workflowConstants } from "../../_constants";
import { LanguagePreferences } from "./LanguagePreferences";
import Stepper from "./Stepper";

class Welcome extends Component {
    static displayName = Welcome.name;

    constructor(props) {
        super(props);
        this.state = {
            steps: [],
            currentStep: 0
        };

        this.handleInput = this.handleInput.bind(this);
        this.handleChangeState = this.handleChangeState.bind(this);
        this.SubmitData = this.SubmitData.bind(this);

    }

    async componentDidMount() {
        if (!this.props.tokenIsValid) {
            //TODO: get user out of here        

            const { dispatch } = this.props;

            dispatch(registrationActions.handleInvalidToken());
        }
        else {

            let workflowData = workflowService.getCurrentWorkflowStepData();

            if (workflowData) {
                this.setState({
                    steps: newLoanStepperService(workflowData.workflowId), currentStep: workflowData.currentStepperStep, SMSUrl: await ServiceUtil.getServiceUrl("SMSUrl"),
                    SMSUrlEs: await ServiceUtil.getServiceUrl("SMSUrlEs")
                });
            }
            else {
                history.push("/LogInMain");
            }
        }
    }

    handleInput = ({ target: { name, value } }) => {

        //const formValue = { ...this.state.formValue, [metadataService.jsonFieldName(name)]: value };

        //this.handleChangeState({ formValue });

        if (name === "LanguagePreference") {
            let currentStep = workflowService.getCurrentWorkflowStepData();
            this.handleChangeState({ steps: newLoanStepperService(currentStep.workflowId) });
        }
    };

    handleChangeState(newState) {
        let nextState = { ...this.state, ...newState }
        this.setState(nextState)
    }

    SubmitData() {
        const { dispatch } = this.props;

        dispatch(registrationActions.handleWelcomeNextRequest(this.props.leadId, this.props.email, this.props.mobilePhoneNumber));
    }

    render() {
        let SMSUrl = userService.getUserLanguage().toLowerCase() === "es" ? this.state.SMSUrlEs : this.state.SMSUrl;
        return (
            <div className="Welcome">
                <Stepper stepData={this.props.steps} currentStep={this.props.currentStep} />

                <div style={{ display: this.state.isBusy ? 'none' : 'block' }}>

                    <Card>
                        <CardBody>
                            <Row>
                                <Col sm={12} md={{ size: 8, offset: 2 }} >
                                    <h1 className="text-center" >{metadataService.getTitle('WelcomeToSunLoan')}</h1>
                                </Col>
                                <Col sm={12} md={{ size: 8, offset: 2 }} >
                                    <p className="text-center" style={{ marginBottom: "0em", fontWeight: "bold" }}>{metadataService.getMessage('WePutPersonal')}</p>
                                    <p className="text-center" style={{ marginTop: "0em" }}>{metadataService.getMessage('WePutPersonal2')}</p>
                                </Col>
                                {workflowService.getCurrentWorkflowStepData().workflowId === workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW &&
                                    <Col sm={12} md={{ size: 10, offset: 1 }} >
                                        {this.props.preApprovalOffer > 0 &&
                                            <p class="text-center">{metadataService.getMessage('WelcomePreApprovalOffer', [this.props.preApprovalOffer])}</p>
                                        }
                                    </Col>
                                }
                            </Row>
                            <Row>
                            </Row>
                            <Row>
                                <Col sm={12} md={{ size: 8, offset: 2 }} >
                                    <p className="text-center">{metadataService.getMessage('WelcomeClickNextMessage')}<a href={SMSUrl} target='_new'>{metadataService.getMessage('WelcomeClickNextMessage2')}</a> {metadataService.getMessage('WelcomeClickNextMessage3')}</p>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <div className="text-center">
                        {workflowService.getCurrentWorkflowStepData().workflowId === workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW
                            ? <SlButton name="Next" onClick={this.SubmitData} />
                            : <SlButton name="GetStarted" onClick={this.SubmitData} />
                        }
                        {this.props.preApprovalOffer > 0 &&
                            <p className="text-field-margin">{metadataService.getMessage("WelcomePreApprovalOffer1")}</p>
                        }
                    </div>
                </div>
            </div >
        );
    }
}

function mapStateToProps(state) {

    const { tokenIsValid, leadId, applicationNumber, email, mobilePhoneNumber, firstName, lastName, preApprovalOffer } = state.newLoan;
    const { loggedIn } = state.authentication;
    const { steps, currentStep } = state.users;
    return {
        tokenIsValid, leadId, applicationNumber, email, mobilePhoneNumber, firstName, lastName, loggedIn, steps, currentStep, preApprovalOffer
    };
}

const connectedWelcome = connect(mapStateToProps)(Welcome);
export { connectedWelcome as Welcome };


// WEBPACK FOOTER //
// ./src/components/subcomponents/Welcome.js